import LegalPageLayout from '../../components/legal/LegalPageLayout';

export default function PrivacyPage() {
  return <LegalPageLayout namespace="privacy" />;
}
